import { DashboardTranslationType } from "../../features/dashboard.types";

export const dashboard: DashboardTranslationType = {
  dashboard: {
    newStory: "قصة جديدة",
    ongoingStories: "القصص الجارية",
    completedStories: "القصص المكتملة",
    loadingStory: "جاري تحميل القصة",
    pleaseWait: "يرجى الانتظار بينما نقوم بتحميل قصتك",
    newCharacter: "شخصية جديدة",
    characterCard: {
      personality: "الشخصية",
      strengths: "نقاط القوة",
      weaknesses: "نقاط الضعف",
      skills: "المهارات"
    },
    search: {
      placeholder: "البحث عن القصص حسب العنوان...",
      characters: "البحث عن الشخصيات..."
    },
    filters: {
      title: "التصفية",
      reset: "إعادة تعيين",
      apply: "تطبيق",
      sortBy: "ترتيب حسب",
      filterByRole: "تصفية حسب الدور",
      name: "الاسم",
      role: "الدور",
      dateCreated: "تاريخ الإنشاء",
      rating: "التقييم", // Added missing key
      allRoles: "جميع الأدوار",
      roles: {
        all: "جميع الأدوار",
        protagonist: "الشخصية الرئيسية",
        antagonist: "الشخصية المعادية",
        deuteragonist: "شخصية ثانوية",
        mentor: "المرشد",
        comic_relief: "شخصية كوميدية",
        mysterious: "شخصية غامضة",
        love_interest: "المصلحة العاطفية",
        anti_hero: "البطل المضاد",
        sidekick: "المساعد",
        shapeshifter: "متغير الشكل",
        guardian: "الحارس",
        catalyst: "المحفز",
        character: "شخصية",
        supporting: "شخصية داعمة"
      }
    },
    deleteStory: {
      confirmTitle: "حذف القصة",
      confirmMessage: "هل أنت متأكد أنك تريد حذف هذه القصة؟ لا يمكن التراجع عن هذا الإجراء.",
      success: "تم حذف القصة",
      successMessage: "تم حذف القصة بنجاح.",
      error: "خطأ",
      errorMessage: "فشل في حذف القصة. يرجى المحاولة مرة أخرى."
    },
    navigation: {
      stories: "القصص",
      characters: "الشخصيات",
      publicStories: "القصص العامة",
      stats: "الإحصائيات",
      more: "المزيد"
    },
    loadingCharacters: "جاري تحميل الشخصيات...",
    noCharactersFound: "لم يتم العثور على شخصيات",
    createCharacter: {
      title: "إنشاء شخصية جديدة",
      editTitle: "تعديل الشخصية",
      new: "شخصية جديدة",
      basicDetails: "التفاصيل الأساسية",
      characteristics: "الخصائص",
      avatarDetails: "المظهر",
      personalityTraits: "السمات الشخصية",
      form: {
        name: "الاسم",
        namePlaceholder: "أدخل اسم الشخصية",
        description: "الوصف",
        descriptionPlaceholder: "أدخل وصف الشخصية",
        role: "الدور",
        selectRole: "اختر دور الشخصية",
        personality: "الشخصية",
        personalityTraits: "السمات الشخصية",
        personalityPlaceholder: "أدخل السمات الشخصية",
        strengths: "نقاط القوة",
        strengthsPlaceholder: "أدخل نقاط قوة الشخصية",
        weaknesses: "نقاط الضعف",
        weaknessesPlaceholder: "أدخل نقاط ضعف الشخصية",
        skills: "المهارات",
        skillsPlaceholder: "أدخل مهارات الشخصية",
        addTrait: "إضافة سمة",
        addStrength: "إضافة قوة",
        addWeakness: "إضافة ضعف",
        addSkill: "إضافة مهارة",
        "add.Personality.Traits": "إضافة سمات الشخصية",
        "add.Strengths": "إضافة نقاط القوة",
        "add.Weaknesses": "إضافة نقاط الضعف",
        "add.Skills": "إضافة المهارات",
        unnamedCharacter: "شخصية بدون اسم",
        cancel: "إلغاء",
        create: "إنشاء الشخصية",
        update: "تحديث الشخصية"
      },
      buttons: {
        create: "إنشاء الشخصية",
        update: "تحديث الشخصية",
        cancel: "إلغاء",
        updating: "جاري التحديث...",
        creating: "جاري الإنشاء...",
      },
      avatarGenerator: {
        genderLabel: "نوع المظهر",
        genderPlaceholder: "اختر نوع المظهر",
        ageLabel: "الفئة العمرية",
        agePlaceholder: "اختر الفئة العمرية",
        hairLabel: "وصف الشعر",
        hairPlaceholder: "مثال: شعر أسود مجعد طويل",
        eyeLabel: "لون العيون",
        eyePlaceholder: "مثال: أزرق عميق",
        clothingLabel: "نمط الملابس",
        clothingPlaceholder: "مثال: درع من العصور الوسطى",
        expressionLabel: "تعبير الوجه",
        expressionPlaceholder: "مثال: ابتسامة واثقة",
        generateButton: "إنشاء الصورة الرمزية",
        generating: "جاري الإنشاء...",
        previewLabel: "الصورة الرمزية المنشأة",
        selectTitle: "اختيار الصورة الرمزية",
        selectDescription: "اختر واحدة من الصور الرمزية المُنشأة لشخصيتك.",
        partialSuccess: "تم إنشاء الصورة الرمزية، ولكن بعض الصور فشلت.",
        someImagesFailed: "فشلت بعض الصور في الإنشاء. يرجى المحاولة مرة أخرى.",
        selectPreferred: "اختر الصورة الرمزية المفضلة",
        genderOptions: {
          male: "إنسان - ذكر",
          female: "إنسان - أنثى",
          // New animal options
          cat: "حيوان - قط",
          dog: "حيوان - كلب",
          wolf: "حيوان - ذئب",
          fox: "حيوان - ثعلب",
          rabbit: "حيوان - أرنب",
          bird: "حيوان - طائر",
          reptile: "حيوان - زاحف",
          // Existing fantasy options
          elf: "خيالي - جني",
          dwarf: "خيالي - قزم",
          orc: "خيالي - أورك",
          vampire: "خيالي - مصاص دماء",
          werewolf: "خيالي - مستذئب",
          fairy: "خيالي - جنية",
          angelic: "خيالي - كائن ملائكي",
          demonic: "خيالي - كائن شيطاني",
          dragonborn: "خيالي - سليل التنين",
          centaur: "خيالي - قنطور",
          mermaid: "خيالي - حورية البحر",
          humanoid_alien: "خيال علمي - كائن فضائي بشري",
          insectoid_alien: "خيال علمي - كائن فضائي حشري",
          reptilian_alien: "خيال علمي - كائن فضائي زاحف",
          cyborg: "خيال علمي - إنسان آلي",
          energy_being: "خيال علمي - كائن طاقة",
          tentacled: "خيال علمي - مخلوق متعدد المجسات",
          cat_person: "حيواني - شخص قط",
          dog_person: "حيواني - شخص كلب",
          wolf_person: "حيواني - شخص ذئب",
          fox_person: "حيواني - شخص ثعلب",
          rabbit_person: "حيواني - شخص أرنب",
          bird_person: "حيواني - شخص طائر",
          reptile_person: "حيواني - شخص زاحف",
          treant: "أسطوري - شجرة متحركة",
          flower: "أسطوري - زهرة واعية",
          vine: "أسطوري - نبات متسلق حي",
          mushroom: "أسطوري - فطر متكلم",
          vegetable: "أسطوري - نبات متحرك",
          golem: "أسطوري - غولم",
          ghost: "أسطوري - شبح/روح",
          shapeshifter: "أسطوري - متحول الشكل"
        },
        ageOptions: {
          child: "طفل",
          teen: "مراهق",
          adult: "بالغ",
          elderly: "مسن"
        },
        success: {
          title: "تم إنشاء الصورة الرمزية",
          description: "تم إنشاء الصورة الرمزية لشخصيتك بنجاح."
        },
        upload: {
          button: "رفع الصورة الرمزية",
          uploading: "جاري الرفع...",
          success: {
            title: "تم رفع الصورة الرمزية",
            description: "تم رفع الصورة الرمزية لشخصيتك بنجاح."
          },
          error: {
            title: "فشل الرفع",
            fileTooLarge: "حجم الملف كبير جداً",
            invalidType: "نوع الملف غير صالح",
            failed: "فشل في رفع الصورة الرمزية. يرجى المحاولة مرة أخرى."
          },
          loading: "جاري التحميل..."
        },
        error: {
          title: "فشل الإنشاء",
          description: "فشل في إنشاء الصورة الرمزية. يرجى المحاولة مرة أخرى."
        }
      },
      messages: {
        successCreated: {
          title: "تم إنشاء الشخصية",
          description: "تم حفظ الشخصية بنجاح.",
        },
        successUpdated: {
          title: "تم تحديث الشخصية",
          description: "تم تحديث الشخصية بنجاح.",
        },
        errorLoad: {
          title: "خطأ",
          description: "فشل في تحميل بيانات الشخصية",
        },
        errorSave: {
          title: "خطأ",
          description: "فشل في حفظ الشخصية. يرجى المحاولة مرة أخرى.",
        },
        validation: {
          characterName: {
            title: "اسم مفقود",
            description: "اسم الشخصية مطلوب.",
          },
        },
      },
    },
    characterManagement: {
      delete: {
        title: "حذف الشخصية",
        confirmMessage: "هل أنت متأكد أنك تريد حذف هذه الشخصية؟ لا يمكن التراجع عن هذا الإجراء.",
        cancel: "إلغاء",
        delete: "حذف",
        deleting: "جاري الحذف...",
        success: {
          title: "تم حذف الشخصية",
          description: "تم حذف الشخصية بنجاح"
        },
        error: {
          title: "خطأ",
          description: "فشل حذف الشخصية"
        }
      },
      visibility: {
        setPrivate: "تم تعيين الشخصية كخاصة",
        setPublic: "تم تعيين الشخصية كعامة",
        nowPrivate: "الشخصية الآن خاصة",
        nowPublic: "الشخصية الآن مرئية للجميع",
        error: "خطأ",
        updateFailed: "فشل في تحديث رؤية الشخصية"
      },
      rating: {
        submitted: "تم إرسال التقييم",
        thankYou: "شكرًا لتقييم هذه الشخصية!",
        error: "خطأ",
        failed: "فشل في إرسال التقييم"
      }
    },
    characterTabs: {
      myCharacters: "شخصياتي",
      publicCharacters: "الشخصيات العامة"
    },
    suggestions: {
      personalities: {
        adaptable: "متكيف",
        ambitious: "طموح",
        brave: "شجاع",
        charismatic: "كاريزمي",
        compassionate: "رحيم",
        confident: "واثق",
        creative: "مبدع",
        determined: "مصمم",
        diplomatic: "دبلوماسي",
        empathetic: "متعاطف",
        honorable: "شريف",
        humble: "متواضع",
        humorous: "فكاهي",
        innovative: "مبتكر",
        loyal: "مخلص",
        optimistic: "متفائل",
        patient: "صبور",
        resilient: "مرن",
        wise: "حكيم",
        analytical: "تحليلي",
        cautious: "حذر",
        eccentric: "غريب الأطوار",
        mysterious: "غامض",
        pragmatic: "عملي",
        reserved: "متحفظ",
        stoic: "رواقي",
        arrogant: "متكبر",
        cynical: "متشكك",
        greedy: "طماع",
        hot_tempered: "سريع الغضب",
        impulsive: "مندفع",
        manipulative: "متلاعب",
        obsessive: "وسواسي",
        paranoid: "مرتاب",
        prideful: "مغرور",
        reckless: "متهور",
        ruthless: "قاسي",
        vengeful: "انتقامي"
      },
      skills: {
        leadership: "قيادة",
        negotiation: "تفاوض",
        perception: "إدراك",
        persuasion: "إقناع",
        investigation: "تحقيق",
        survival: "بقاء",
        deception: "خداع",
        intimidation: "ترهيب",
        performance: "أداء",
        medicine: "طب",
        sword_fighting: "مبارزة بالسيف",
        archery: "رماية",
        martial_arts: "فنون قتالية",
        stealth: "تخفي",
        acrobatics: "بهلوانية",
        marksmanship: "رماية دقيقة",
        hand_to_hand: "قتال باليد",
        tactical: "تخطيط تكتيكي",
        magic: "سحر",
        elemental_control: "تحكم بالعناصر",
        healing: "شفاء سحري",
        necromancy: "سحر الموتى",
        prophecy: "تنبؤ",
        shapeshifting: "تغيير الشكل",
        telepathy: "تخاطر",
        telekinesis: "تحريك عن بعد",
        alchemy: "خيمياء",
        summoning: "استدعاء",
        hacking: "اختراق",
        piloting: "قيادة مركبات فضائية",
        robotics: "روبوتات",
        cybernetics: "تحسينات إلكترونية",
        nanotech: "تقنية النانو",
        quantum_physics: "فيزياء الكم",
        ai_programming: "برمجة الذكاء الاصطناعي",
        bioengineering: "هندسة حيوية",
        time_manipulation: "التلاعب بالزمن",
        energy_weapons: "أسلحة طاقة",
        crafting: "حرف",
        cooking: "طبخ",
        music: "أداء موسيقي",
        art: "إبداع فني",
        writing: "كتابة",
        forgery: "تزوير",
        invention: "اختراع",
        linguistics: "لغويات",
        history: "تاريخ",
        science: "علوم",
        psychology: "علم النفس",
        archaeology: "علم الآثار",
        cryptography: "تشفير",
        strategy: "استراتيجية",
        mythology: "علم الأساطير",
        economics: "اقتصاد"
      }
    },
    publicStories: "القصص العامة",
    upgradeForMore: "الترقية للمزيد",
    storiesRemaining: "قصص متبقية اليوم",
    storiesAvailable: "قصص متاحة اليوم",
    by: "بواسطة",
    anonymous: "مجهول",
    completed: "مكتملة",
    public: "عامة",
    makePublic: "جعلها عامة",
    makePrivate: "جعلها خاصة",
    upgradeToMakePublic: "قم بالترقية لجعل القصص عامة",
    error: "خطأ",
    rating: {
      submitted: "تم إرسال التقييم",
      thankYou: "شكراً لتقييمك لهذه القصة!",
      failed: "فشل في إرسال التقييم"
    },
    upgrade: {
      required: "الترقية مطلوبة",
      description: "قم بترقية حسابك لجعل القصص عامة ومشاركتها مع الآخرين.",
      shareStories: "شارك قصصك مع اشتراك مميز",
      now: "الترقية الآن"
    },
    startedTime: "بدأت {{time}}",
    storyVisibility: {
      madePublic: "تم جعل القصة عامة",
      madePrivate: "تم جعل القصة خاصة", 
      publicDescription: "يمكن للآخرين الآن مشاهدة هذه القصة",
      privateDescription: "هذه القصة الآن خاصة"
    },
    stats: {
      tabs: {
        badges: "الشارات",
        stories: "القصص",
        characters: "الشخصيات",
        engagement: "المشاركة"
      },
      badges: {
        loading: "جاري تحميل الشارات...",
        earned: "تم الحصول عليها:",
        error: {
          title: "خطأ",
          loadBadges: "فشل تحميل الشارات",
          loadProgress: "فشل تحميل تقدم الشارات"
        },
        items: {
          "06491397-1302-45c5-85f7-31e5c46ed3d9": {
            name: "كاتب غزير",
            description: "أكمل 100 قصة",
            category: "كتابة"
          },
          "0b4b084c-4344-4ad0-9b0c-99b03e6fccc8": {
            name: "روائي تاريخي",
            description: "أكمل 3 قصص خيال تاريخي",
            category: "الأنواع الأدبية"
          },
          "1a86f197-46e4-4158-bc93-461d83d52b5e": {
            name: "كاتب التحمل",
            description: "اكتب ردودًا لمدة 30+ يومًا متتاليًا",
            category: "كتابة"
          },
          "21a94bad-5405-4d27-ab85-2d4049d708aa": {
            name: "حلال الألغاز",
            description: "أكمل 10 قصص غموض",
            category: "الأنواع الأدبية"
          },
          "22e8ee37-d737-41ee-be9b-c3aa2e6d6898": {
            name: "مهندس الحوار",
            description: "ساهم بـ 10,000 كلمة من الحوار من خلال التفاعلات",
            category: "كتابة"
          },
          "258f5de2-f824-4bf1-adaf-e06df8cb27d0": {
            name: "ناقد متميز",
            description: "قيّم 20 شخصية",
            category: "المجتمع"
          },
          "2fb0b566-d564-4b54-8f74-b39130099161": {
            name: "باني العلاقات",
            description: "أنشئ علاقات بين 5 شخصيات",
            category: "الشخصيات"
          },
          "59fd8282-02b7-49d9-912b-3137e5b72cf2": {
            name: "الإحساس الفيروسي",
            description: "تحصل قصة على أكثر من 1000 مشاهدة",
            category: "اجتماعي"
          },
          "5a867724-a8ab-4ddd-a85c-b5864a5f8387": {
            name: "المفكر العميق",
            description: "أضف قصة خلفية مفصلة لـ 3 شخصيات",
            category: "الشخصيات"
          },
          "66cc4e5d-2a9e-48d7-ae08-4d51993b4693": {
            name: "الفراشة الاجتماعية",
            description: "قيّم 20 قصة",
            category: "المجتمع"
          },
          "741e00ae-a32d-4495-9191-bd52d90389d2": {
            name: "عاشق الرعب",
            description: "أكمل 20 قصص رعب",
            category: "الأنواع الأدبية"
          },
          "8a28897b-8993-4b11-a9c6-490703d87066": {
            name: "بادئ السلسلة",
            description: "انشر القصة الأولى في سلسلة متعددة الأجزاء",
            category: "كتابة"
          },
          "98ed9a67-4eb9-4c2c-b119-ab270373346a": {
            name: "الصوت المتوازن",
            description: "حقق المزيد من الردود المعدلة من قبل المستخدم",
            category: "كتابة"
          },
          "99820441-a9eb-4c9e-a044-80dcf23c0dd6": {
            name: "سيد الإحالة",
            description: "ادعُ واحصل على انضمام 10 أصدقاء",
            category: "اجتماعي"
          },
          "b19a40af-d02c-4e68-9cf2-29ed0609132b": {
            name: "المشجع",
            description: "امنح 20+ تفاعلًا إيجابيًا للقصص",
            category: "المجتمع"
          },
          "bb25222d-2bf7-4c3d-9c69-3ee6fdc8f74c": {
            name: "سيد الإرشادات",
            description: "قدم 100 إرشاد فريد للمستخدم",
            category: "كتابة"
          },
          "d6178364-f775-483b-ac86-ebcab6f469df": {
            name: "المروج",
            description: "شارك 5 قصص على وسائل التواصل الاجتماعي",
            category: "اجتماعي"
          },
          "d9d3b0ad-5512-4f57-afc4-02795f488cea": {
            name: "هامس الذكاء الاصطناعي",
            description: "اقبل ردودًا تم إنشاؤها بواسطة الذكاء الاصطناعي 500 مرة",
            category: "كتابة"
          },
          "dcbda3da-f44f-468e-b650-0ba2b49de57b": {
            name: "فنان الشخصيات",
            description: "إنشاء صورة رمزية لشخصية",
            category: "الشخصيات"
          },
          "f2f6cb19-eff1-40cb-90e7-d69a13b1cee6": {
            name: "الكاتب اليومي",
            description: "إنشاء قصة لمدة 7 أيام متتالية",
            category: "كتابة"
          },
          "f793ac53-913f-4b17-a534-08d34a768544": {
            name: "طاقم ديناميكي",
            description: "استخدم 20+ شخصية مختلفة في القصص",
            category: "الشخصيات"
          },
          "f949c0fc-ffab-4c4b-8cb9-050af34bfd66": {
            name: "المجرب",
            description: "أكمل في 10+ أنواع مختلفة",
            category: "الأنواع الأدبية"
          }
        }
      },
      storyStats: {
        loading: "جاري تحميل الإحصائيات...",
        totalStories: "إجمالي القصص",
        completed: "مكتملة",
        published: "منشورة",
        averageRating: "متوسط التقييم",
        categoryRelationships: "علاقات الفئات",
        primaryCategory: "الفئة الأساسية",
        secondaryCategory: "الفئة الثانوية",
        selectCategory: "اختر الفئة",
        genre: "النوع الأدبي",
        themes: "المواضيع",
        environment: "البيئة",
        noCategoryData: "لا تتوفر بيانات الفئات",
        lessFrequent: "أقل تكراراً",
        moreFrequent: "أكثر تكراراً",
        usageDescription: "يوضح مدى تكرار استخدام الفئات معًا في قصصك",
        stories: "قصص",
        noDataAvailable: "لا تتوفر بيانات",
      },
      characterStats: {
        loading: "جاري تحميل إحصائيات الشخصيات...",
        totalCharacters: "إجمالي الشخصيات",
        publicCharacters: "الشخصيات العامة",
        averageRating: "متوسط التقييم",
        traitRelationships: "علاقات سمات الشخصية",
        primaryTraitType: "نوع السمة الأساسية",
        secondaryTraitType: "نوع السمة الثانوية",
        selectTraitType: "اختر نوع السمة",
        personalityTraits: "سمات الشخصية",
        strengths: "نقاط القوة",
        weaknesses: "نقاط الضعف",
        skills: "المهارات",
        noTraitData: "لا تتوفر بيانات علاقات السمات",
        lessFrequent: "أقل تكراراً",
        moreFrequent: "أكثر تكراراً",
        usageDescription: "يوضح مدى تكرار ظهور سمات مختلفة معًا في شخصياتك",
        characters: "شخصيات"
      },
      engagementStats: {
        loading: "جاري تحميل الإحصائيات...",
        totalStories: "إجمالي القصص",
        avgCustomization: "متوسط التخصيص",
        avgWordCount: "متوسط عدد الكلمات",
        currentStreak: "التتابع الحالي",
        days: "أيام",
        monthlyProgress: "التقدم الشهري"
      }
    },
    author: {
      title: 'الملف الشخصي للمؤلف',
      credits: 'رصيد القصص',
      creditsAvailable: 'لديك {{count}} رصيد متاح',
      memberSince: 'عضو TaleCraft',
      loading: 'جار التحميل...',
      recentBadges: 'الشارات الأخيرة',
      noBadgesYet: 'لم يتم كسب أي شارات بعد',
      earnedOn: 'تم الحصول عليها في {{date}}',
      more: 'المزيد'
    },
    access: {
      restricted: "مقيد",
      loginRequired: "تسجيل الدخول مطلوب",
    }
  }
};
